import { useQuery } from 'react-query';
import { GetCtaSetParams, GetCtaSetResponse } from '../types';
import { EXPRESS_API } from '../../configs/api/expressApi';

export const getExitLinksSets = async (
  params: GetCtaSetParams
): Promise<GetCtaSetResponse> => {
  return (await EXPRESS_API.get(`/exitlinksets`, { params }))
    .data as GetCtaSetResponse;
};

export const useGetLinkSetsQuery = (
  params: GetCtaSetParams,
  enabled: boolean = true
) => {
  return useQuery(['EXIT_LINKS_QUERY'], () => getExitLinksSets(params), {
    enabled: enabled,
    refetchOnMount: true,
  });
};
